const modules = import.meta.glob('./*/*.ts', { eager: true });

const messages: Record<string, Record<string, Record<string, unknown>>> = {};

Object.keys(modules).forEach((path) => {
  const match = path.match(/\.\/([^/]+)\/([^/]+)\.ts$/);
  if (match) {
    const [, lang, namespace] = match;
    const module = modules[path] as Record<string, unknown>;

    if (!messages[lang]) {
      messages[lang] = {};
    }

    // 使用文件名作为命名空间，读取具名导出
    const namedExport = module[namespace];
    if (namedExport && typeof namedExport === 'object') {
      messages[lang][namespace] = namedExport as Record<string, unknown>;
    }
  }
});

export default messages;
